<template>
  <div class="list">
    <h2>Inventaire</h2>
      <!-- {{ list }} -->
      <el-alert
        title="information"
        type="info"
        show-icon
        v-if="true">
      Saisissez votre inventaire {{ dateSaisie }}
      </el-alert>

      <!-- <el-alert
      title="Nouveautés sur l'application inventaire :"
      type="warning"
      show-icon>
        - Plus de texte pour décrire 2.<br/>
        - Plus de texte pour décrire 2.<br/>
        - Plus de texte pour décrire 2.<br/>
      </el-alert> -->
      <!-- description="Plus de texte pour décrire." -->
      <el-card class="box-card box-card-message-inventaire"
        v-if="frontEndMessages.length !== 0">
        <div slot="header" class="clearfix">
          <span>Message</span>
          <el-tooltip class="item" effect="dark"
            content="Section message" placement="bottom">
            <i class="el-icon-question"
            style="float: right;font-size: 30px;padding: 0;color: #909399;"></i>
          </el-tooltip>
        </div>
        <!-- <div v-if="frontEndMessages.length === 0"
          style="font-style: italic;">
          Aucun message.
        </div> -->
        <el-alert
        v-for="(message) in frontEndMessages" :key="message.id"
        :title="message.title"
        type="warning"
        style="margin: 0 0 5px 0px;"
        show-icon>
          <i class="el-icon-s-flag new-message-icon"
          v-if="message.newMessage"></i>
          <div v-for="(messageText, index) in message.messages" :key="index"
          >- {{ messageText }}</div>
        </el-alert>
        <!-- <el-alert
        :title="typeInventaire"
        type="warning"
        v-if="hasListing">
          </el-alert> -->
      </el-card>

      <div class="no-saisie-text" v-if="!hasListing">
        Aucune saisie pour le moment.
      </div>

      <!-- <div v-if="displayButtonImport"> -->
      <div v-if="!hasListing">
      <!-- <div> -->
        <el-alert
           title="Cliquez sur le bouton ci-dessous pour générer l'inventaire"
           type="info"
           show-icon>
        </el-alert>
        <el-button type="primary"  icon="el-icon-download"
          class="button-action-gener-inventaire"
          @click="createInventaireProducts">
          Générer l'inventaire
        </el-button>
     </div>

     <div v-if="displayEmbed">
       <el-button type="primary"
        icon="el-icon-back"
        class="button-action-back-list"
        @click="displayListProducts"
        >Retour à la saisie</el-button>
       <embed :src="pdfUrl" width="80%" height="700"
       class="embedPdf"
       type='application/pdf'>
     </div>
     <div v-if="!displayEmbed">
        <ButtonsAction
          :listLength="hasListing"
          :hasFamilyEmpty="hasFamilyEmpty"
          @onPrint="print"
          @onValidate="validate" />

        <!-- <el-button type="primary" @click="print"
        v-if="list.length > 0">Imprimer</el-button> -->
        <div id="for-print">
          <div class="content-family-for-print hidden"
          v-for="(listProduct,family) in list" :key="family">
            <span style="font-weight:bold;">{{ family }}</span>
            <table border="1" width="950px">
              <thead>
                <tr>
                  <td style="text-align:center;" width="600px">Nom</td>
                  <td style="text-align:center;" width="150px">Unité</td>
                  <td style="text-align:center;" width="100px">Zone avant</td>
                  <td style="text-align:center;" width="100px">Zone arrière</td>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(product,index) in listProduct" :key="index" >
                  <td>{{ product.name }}</td>
                  <td style="text-align:center;">{{ product.unit }}</td>
                  <td>{{ product.quantityAreaSelling !== 0 ?
                    product.quantityAreaSelling : '' }}</td>
                  <td>{{ product.quantityAreaStock !== 0 ? product.quantityAreaStock : '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div>
          <vue-html2pdf
             :show-layout="false"
             :float-layout="true"
             :enable-download="false"
             :preview-modal="true"
             :paginate-elements-by-height="10000"
             filename="liste_des_produits"
             :pdf-quality="2"
             :manual-pagination="false"
             pdf-format="a4"
             pdf-orientation="portrait"
             pdf-content-width="950px"
             :html-to-pdf-options="htmlToPdfOptions"
             @beforeDownload="beforeDownload()"
             @hasDownloaded="hasGenerated($event)"

             ref="html2Pdf"
         >
         <!--
         @progress="onProgress($event)"
       -->
             <section slot="pdf-content">
                 <!-- PDF Content Here -->
                 <div class=""
                 v-for="(listProduct,family) in list" :key="family">
                   <span style="font-weight:bold;">{{ family }}</span>
                   <!-- <table border="1" width="700px"> -->
                   <table border="1" width="700px">
                     <thead>
                       <tr>
                         <th style="text-align:center;width:60%" >Nom</th>
                         <th style="text-align:center;width:30%" >Unité</th>
                         <th style="text-align:center;width:5%" >Zone avant</th>
                         <th style="text-align:center;width:5%" >Zone arrière</th>
                       </tr>
                     </thead>
                     <tbody>
                       <!-- :class="[product.paginateForPdf ? 'html2pdf__page-break' : '']" -->
                       <!-- :class="[index === 35 ? 'html2pdf__page-break' : '']" -->
                       <tr v-for="(product,index) in listProduct"
                        :key="index" >
                         <td>{{ product.name }}</td>
                         <td style="text-align:center;">{{ product.unit }}</td>
                         <td>
                           {{ product.quantityAreaSelling !== 0 ?
                             product.quantityAreaSelling : '' }}
                         </td>
                         <td>
                           {{ product.quantityAreaStock !== 0 ? product.quantityAreaStock : '' }}
                         </td>
                       </tr>
                     </tbody>
                   </table>
                 </div>
             </section>
         </vue-html2pdf>
        </div>

        <div id="list-products">
          <el-collapse>
            <el-collapse-item v-for="(listProduct,family) in list"
            :name="family" :key="family" >
            <!-- :title="family" :name="family" :key="family" > -->
                <template slot="title">
                  {{ family }}
                  <!-- <el-tooltip v-if="sumFilled(family) === 0"  class="item" -->
                  <el-tooltip v-if="familyIsNotCompleted(family)"  class="item"
                    content="Cette famille est incomplète.
                    Tous les produits doivent être saisis correctement."
                    effect="dark"
                    placement="right">
                    <!-- <div slot="content">Cette famille est incomplète.
                    Les produits avec une étoile <i class="el-icon-star-on icon-can-be-empty"></i>
                    doivent être saisis correctement.</div> -->
                    <i v-if="familyIsNotCompleted(family)"
                      class="header-icon icon-family-not-filled el-icon-circle-close">
                    </i>
                  </el-tooltip>
                  <el-tooltip v-if="!familyIsNotCompleted(family)"  class="item"
                    effect="dark"
                    content="Cette famille est complète."
                    placement="right">
                    <i v-if="!familyIsNotCompleted(family)"
                      class="header-icon icon-family-not-filled el-icon-circle-check">
                    </i>
                  </el-tooltip>
                </template>
                <ProductSaisie
                :key="index"
                :product="product"
                :valeurAnormale="valeurAnormale(product)"
                :productsAverageQty="getProductsAverageQty(product.productId)"
                @onInput="saveQuantity"
                v-for="(product,index) in listProduct" />
            </el-collapse-item >
          </el-collapse>
        </div>
        <ButtonsAction
          :listLength="hasListing"
          :hasFamilyEmpty="hasFamilyEmpty"
          @onPrint="print"
          @onValidate="validate" />
      </div>
      <!-- <el-backtop target=".box-card-message-inventair"></el-backtop> -->
  </div>
</template>

<script>
import moment from 'moment';
import _ from 'lodash';
import { Message } from 'element-ui';
import VueHtml2pdf from 'vue-html2pdf';
/* eslint-disable */
import autoTable from 'jspdf-autotable';
/* eslint-disable */
import jsPDF from 'jspdf';
import ButtonsAction from '@/components/Inventaire/ButtonsAction.vue';
import ProductSaisie from '@/components/Inventaire/ProductInventory.vue';

export default {
  components: {
    ProductSaisie,
    ButtonsAction,
    VueHtml2pdf,
    // Card,
  },
  props: {
    list: Object,
    inventaireHead: Object,
    listInventaireProductsAverageQty: Object,
    frontEndMessages: Array,
  },
  data() {
    return {
      errors: [],
      traiterEvenementDebounce: null,
      showLoader: null,
      indexArray: 0,
      quantitySaving: false,
      htmlToPdfOptions: {
        margin: [10, 10],
        filename: 'hehehe.pdf',
        // image: {
        //     type: 'jpeg',
        //     quality: 0.98
        // },
        // enableLinks: false,
        // html2canvas: {
        //     scale: 1,
        //     useCORS: true
        // },
        jsPDF: {
          pagesplit: true,
          // unit: 'in',
          // format: 'a4',
          // orientation: 'portrait'
        },
      },
      pdfUrl: '',
      displayEmbed: false,
    };
  },
  computed: {
    dateSaisie() {
      if (this.inventaireHead.dateBeg) {
        let dateBeg = this.inventaireHead.dateBeg.toDate();
        dateBeg = moment(dateBeg);
        console.log(dateBeg);
        if (moment().isBefore(dateBeg)) {
          dateBeg = dateBeg.format('DD/MM/YYYY HH:mm');
          const value = `- Prochain inventaire : ${dateBeg}`;
          return value;
        }
      }
      if (this.inventaireHead.dateEnd) {
        let dateEnd = this.inventaireHead.dateEnd.toDate();
        dateEnd = moment(dateEnd);
        dateEnd = dateEnd.format('DD/MM/YYYY HH:mm');
        const value = `- Date limite : ${dateEnd}`;
        return value;
      }
      return '';
    },
    typeInventaire() {
      if (this.inventaireHead.inventoryId) {
        const inventoryType = _.get(this.inventaireHead, 'inventoryType', 'INV_CLASSIQUE');
        let value = '';
        if (inventoryType === 'INV_CLASSIQUE') {
          value = 'Inventaire périodique ';
        } else {
          value = 'Inventaire produit et hygiene ';
        }
        return value;
      }
      return '';
    },
    hasListing() {
      return !_.isEmpty(this.list);
    },
    hasFamilyEmpty() {
      let res = false;
      _.forEach(this.list, (listProduct, family) => {
        if (this.familyIsNotCompleted(family) === true) {
          res = true;
        }
      });
      return res;
    },
    displayButtonImport() {
      console.log('displayButtonImport');
      console.log(this.inventaireHead);
      let status = false;
      if (this.inventaireHead.status !== undefined
        && this.inventaireHead.status === 'A') {
        status = true;
      }
      let dateBegBefore = false;
      if (this.inventaireHead.dateBeg) {
        let dateBeg = this.inventaireHead.dateBeg.toDate();
        dateBeg = moment(dateBeg);
        // console.log(dateBeg);
        if (moment().isAfter(dateBeg)) {
          dateBegBefore = true;
        }
      }
      let dateEndAfter = false;
      if (this.inventaireHead.dateEnd) {
        let dateEnd = this.inventaireHead.dateEnd.toDate();
        dateEnd = moment(dateEnd);
        // console.log(dateBeg);
        if (moment().isBefore(dateEnd)) {
          dateEndAfter = true;
        }
      }
      return _.isEmpty(this.list)
        && status
        && dateBegBefore
        && dateEndAfter;
    },
  },
  watch: {
    frontEndMessages: function (arr) {
      _.forEach(arr, (message) => {
        if(message.newMessage) {
          console.log('on affiche une alert pour dire nouv message');
          const text = `Veuillez consulter le nouveau message dans
            la section message en haut de la page.<br/>
            Les nouveaux messages sont indiqués par cette icône
            <i class="el-icon-s-flag" style="font-size: 20px;color: #f56c6c;"></i>`;
          this.$alert(text, "Nouveau message", {
            confirmButtonText: 'OK',
            type: 'info',
            dangerouslyUseHTMLString: true,
            // customClass: 'message-box-validate-inv',
          });
          return false;
        }
      });
    },
  },
  methods: {
    displaySuccessMessage(message) {
      this.$message({
        showClose: true,
        message,
        type: 'success',
      });
    },
    displayErrorMessage(message) {
      this.$message({
        showClose: true,
        message,
        type: 'error',
      });
    },
    async saveQuantity(data) {
      this.quantitySaving = true;
      Message.closeAll();
      if (this.checkIfInvenaireIsEditable()) {
        try {
          console.log('Catch emit OnInput');
          console.log(data);
          if (data.quantityAreaStock === undefined && data.quantityAreaSelling === undefined) {
            console.log('error CEST UNDEFINED !!!!');
            await Promise.reject();
          }
          // this.$store.dispatch('inventory/setQuantityInventory', { data });
          const resultSetQuantity = await this.$store.dispatch('inventaire/setQuantityInventory', { data });
          const {
            productId, quantityAreaStock, quantityAreaSelling, nameDisplayed, unit,
            inventoryId, family,
          } = data;
          if (resultSetQuantity === null) {
            this.$mixpanel.track('Saisie quantité erronée - inventaire', {
              app: 'inventaire', productId, quantityAreaStock, quantityAreaSelling, nameDisplayed, unit, inventoryId, family,
              userAgent: navigator.userAgent, screenHeight: window.screen.height, screenWidth: window.screen.width,
            });
            this.displayErrorMessage('Erreur d\'enregistrement.');
          } else {
            this.$mixpanel.track('Saisie quantité succès - inventaire', {
              app: 'inventaire', productId, quantityAreaStock, quantityAreaSelling, nameDisplayed, unit, inventoryId, family,
              userAgent: navigator.userAgent, screenHeight: window.screen.height, screenWidth: window.screen.width,
            });
            if (data.quantityAreaStock === null || data.quantityAreaSelling === null) {
              // this.$message('Quantité effacée avec succès.');
              this.$message({
                message: 'Merci de saisir une valeur.',
                type: 'warning'
              });
            } else {
              this.displaySuccessMessage('Enregistrement avec succès.');
            }
          }
        } catch (error) {
          this.$mixpanel.track('Saisie quantité erronée - inventaire', {
            app: 'inventaire', product: data,
            userAgent: navigator.userAgent, screenHeight: window.screen.height, screenWidth: window.screen.width,
          });
          this.displayErrorMessage('Erreur d\'enregistrement.');
          // console.error(error);
        }
      }
      this.quantitySaving = false;
    },
    print() {
      const { inventoryId, storeId } = this.inventaireHead;
      this.$mixpanel.track('Impression papier - inventaire', { app: 'inventaire', inventoryId,
      userAgent: navigator.userAgent, screenHeight: window.screen.height, screenWidth: window.screen.width, });
      // Pass the element id here
      // this.$htmlToPaper('for-print');
      /*
      this.showLoader = this.$loading({
        lock: true,
        text: 'Chargement du fichier PDF',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      this.$refs.html2Pdf.generatePdf();
      */
      // console.log(this.list.Emballage);
      const columns = [
        { title: 'Nom', dataKey: 'nameDisplayed' },
        { title: 'Unité de comptage', dataKey: 'unit' },
        { title: 'Zone avant', dataKey: 'quantityAreaSelling' },
        { title: 'Zone arrière', dataKey: 'quantityAreaStock' },
      ];
      /* eslint-disable */
      const doc = new jsPDF({
        orientation: 'portrait',
        unit: 'in',
        format: 'letter',
      });
      doc.setProperties({
        title: `${inventoryId}-${storeId}.pdf`
      });
      let firstLoop = true;
      _.forEach(this.list, (listProd, family) => {
        // text is placed using x, y coordinates
        // const posY = doc.autoTable.previous.finalY === undefined ? 1 : doc.autoTable.previous.finalY + 0.3;
        const posY = firstLoop === true ? 1 : doc.autoTable.previous.finalY + 0.3;
        // doc.setFontSize(16).text(family, 0.5, 1.0);
        doc.setFontSize(16)
        .setTextColor(64, 158, 255)
        .text(family, 0.5, posY);
        // doc.setFontSize(16).text(family);
        // create a line under heading
        // doc.setLineWidth(0.01).line(0.5, posY + 0.1, 8.0, posY + 0.1);
        // on map pour remplacer les 0 par ""
        const map = listProd.map(prod => {
          const data = { ...prod };
          data.quantityAreaSelling = data.quantityAreaSelling === 0 ? '' : data.quantityAreaSelling;
          data.quantityAreaStock = data.quantityAreaStock === 0 ? '' : data.quantityAreaStock;
          data.nameDisplayed = data.highlightName === true ? `/!\\    ${data.nameDisplayed}` : data.nameDisplayed;
          data.unit = data.highlightPackaging === true ? `/!\\    ${data.unit}` : data.unit;
          return data;
        });
        // const marginTop =  doc.autoTable.previous.finalY === undefined ? 1.1 : 0.5;
        const marginTop =  firstLoop === true === undefined ? 1.1 : 0.5;
        // Using autoTable plugin
        doc.autoTable({
          columns,
          body: map,
          startY: posY + 0.15,
          // body: this.items,
          margin: { left: 0.5, top: marginTop },
          // theme: "grid",
          styles: { lineWidth: 0.01, halign: 'center' },
          columnStyles: {
            0: {cellWidth: 4, cellPadding: 0.12},
            1: {cellWidth: 1.5, cellPadding: 0.12},
            2: {cellWidth: 1, cellPadding: 0.12},
            3: {cellWidth: 1, cellPadding: 0.12},
          },
          /*
          willDrawCell: function(data) {
            // cellule vide
            if (data.column.dataKey === 'nameDisplayed') {
                if (data.row.raw.priority === true) {
                  console.log(data);
                    // doc.setTextColor(231, 76, 60); // Red
                    // doc.setFontStyle('bold');
                    doc.setFont('helvetica', 'bold');
                    // doc.setFontSize(15);
                    // data.cell.styles.fillColor = [243, 156, 18];
                }
            }
          },
          */
          didParseCell: function(cell, data) {
            // console.log('data createdCell');
            // console.log(cell);
            // cellule Couleur
            if (cell.row.section === 'body' && cell.column.dataKey === 'nameDisplayed') {
               if (cell.row.raw.priority === true) {
                 cell.cell.styles.fillColor = [53, 59, 72];
                 cell.cell.styles.textColor = [255, 255, 255];
                 cell.cell.styles.fontStyle = 'bold';
               }
               if (cell.row.raw.highlightName === true) {
                 cell.cell.styles.fillColor = [53, 59, 72];
                 cell.cell.styles.textColor = [103, 194, 58];
                 cell.cell.styles.fontStyle = 'bold';
                 cell.cell.styles.fontSize = 12;
                 console.log(cell);
               }
             }
            if (cell.row.section === 'body' && cell.column.dataKey === 'unit') {
               if (cell.row.raw.highlightPackaging === true) {
                 cell.cell.styles.fillColor = [53, 59, 72];
                 cell.cell.styles.textColor = [103, 194, 58];
                 cell.cell.styles.fontStyle = 'bold';
                 cell.cell.styles.fontSize = 12;
               }
             }
          },
          didDrawCell: function(data) {
            // Cellule image
            if (data.row.section === 'body' && data.column.dataKey === 'quantityAreaSelling') {
             // console.log('data didDrawCell');
             // console.log(data);
             if (data.row.raw.displayAreaSelling === false) {
               const img = 'cell-background.jpg';
               const dim = data.cell.height - data.cell.padding('vertical');
               const textPos = data.cell;
               doc.addImage(img, textPos.x,  textPos.y, data.cell.width, data.cell.height);
               // doc.addImage(img,0,0, dim, dim);
             }
           }
          }
        });
        firstLoop = false;
      });

      // Using array of sentences
      // doc
      //   .setFont('helvetica')
      //   .setFontSize(12)
      //   .text(this.moreText, 0.5, 3.5, { align: 'left', maxWidth: '7.5' });

      // Creating footer and saving file
      const str = doc
        .setFont('times')
        .setFontSize(11)
        // .setFontStyle('italic')
        .setTextColor(0, 0, 255)
        .text(
          "N'oubliez pas de saisir informatiquement",
          0.5,
          doc.internal.pageSize.height - 0.5,
        )
        // .save(`${inventoryId}-${storeId}.pdf`)
        .output('datauristring')
        ;
        this.pdfUrl = str;
        this.displayEmbed = true;
        // doc.save(`${inventoryId}-${storeId}.pdf`);
    },
    async validate() {
      Message.closeAll();
      if (this.checkIfInvenaireIsEditable()) {
        const loader = this.$loading({
          lock: true,
          text: "Clôture de l'inventaire en cours",
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
        });
        try {
          if (this.hasFamilyEmpty || this.quantitySaving) {
            await Promise.reject();
          }
          // const { inventoryId, storeId } = this.list.length > 0
          // ? this.list[0] : { inventoryId: 0, storeId: 0 };
          const { inventoryId, storeId } = this.inventaireHead;
          const result = await this.$store.dispatch('inventaire/validInventaire', { inventoryId, storeId });
          console.log(result);
          if (result === null) {
            this.$mixpanel.track('Inventaire validée(erreur) - inventaire', {
              app: 'inventaire', inventoryId,
              userAgent: navigator.userAgent, screenHeight: window.screen.height, screenWidth: window.screen.width,
            });
            loader.close();
            this.displayErrorMessage('Erreur lors de validation.');
          } else {
            this.$mixpanel.track('Inventaire validée(succès) - inventaire', {
              app: 'inventaire', inventoryId,
              userAgent: navigator.userAgent, screenHeight: window.screen.height, screenWidth: window.screen.width,
            });
            loader.close();
            this.displaySuccessMessage('Inventaire clôturé avec succès.');
          }
        } catch (error) {
          this.$mixpanel.track('Inventaire validée(erreur) - inventaire', {
            app: 'inventaire', inventaireHead: this.inventaireHead,
            userAgent: navigator.userAgent, screenHeight: window.screen.height, screenWidth: window.screen.width,
          });
          loader.close();
          this.displayErrorMessage('Erreur lors de validation.');
          // console.error(error);
        }
      }
    },
    checkIfInvenaireIsEditable() {
      let status = false;
      if (this.inventaireHead.status !== undefined
        && this.inventaireHead.status === 'A') {
        status = true;
      }
      let dateEndAfter = false;
      if (this.inventaireHead.dateEnd) {
        let dateEnd = this.inventaireHead.dateEnd.toDate();
        dateEnd = moment(dateEnd);
        // console.log(dateBeg);
        if (moment().isBefore(dateEnd)) {
          dateEndAfter = true;
        }
      }
      if (status && dateEndAfter) {
        return true;
      }
      const text = `Vous ne pouvez plus saisir ni clôturer votre inventaire,
      la date limite est depassée.`;
      const type = 'error';
      this.$alert(text, "Erreur", {
        confirmButtonText: 'OK',
        type,
        dangerouslyUseHTMLString: true,
        customClass: 'message-box-validate-inv',
      });
      this.$store.dispatch('inventaire/fetchProductsByStore');
      this.$store.dispatch('inventaire/fetchInventaireByStore');
      return false;
    },
    getProductsAverageQty(productId) {
      // console.log('getProductsAverageQty');
      // console.log(_.get(this.listInventaireProductsAverageQty, productId, 2));
      return _.get(this.listInventaireProductsAverageQty, productId, 2);
    },
    sumFilled(family) {
      // a supprimer si on utilise familyIsNotCompleted
      // return _.size(this.list[family]);
      return _.sumBy(this.list[family],
        (product) => product.quantityAreaSelling + product.quantityAreaStock);
    },
    familyIsNotCompleted(family) {
      return _.some(this.list[family], (product) => {
        return this.valeurAnormale(product)
        || (product.canBeEmpty === false && product.displayAreaSelling === true
          && (product.quantityAreaSelling === undefined || product.quantityAreaStock === undefined))
        || (product.canBeEmpty === false && product.displayAreaSelling === false &&
          product.quantityAreaSelling === undefined && product.quantityAreaStock === undefined);
      });
    },
    valeurAnormale(product) {
      const { quantityMax, quantityMin } = product;
      const quantityAreaSelling = _.get(product, 'quantityAreaSelling', 0);;
      const quantityAreaStock = _.get(product, 'quantityAreaStock', 0);
      const total = parseFloat(quantityAreaSelling) + parseFloat(quantityAreaStock);
      if(quantityMin !== null && quantityMax !== null){
        if (!Number.isNaN(total)
          && !_.inRange(total, parseFloat(quantityMin), parseFloat(quantityMax))
          && total !== parseFloat(quantityMax)) {
          // total !== parseFloat(quantityMax) --> inRange non inclusive
          // console.log('valeurAnormale TRUE '+product.productId)
          return true;
        }
      }
      return false;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    beforeDownload() {
      console.log('Debut chargement PDF');
      // this.showLoader = this.$loading({
      //     lock: true,
      //     text: 'Chargement du fichier PDF',
      //     spinner: 'el-icon-loading',
      //     background: 'rgba(0, 0, 0, 0.7)'
      //   });
    },
    hasGenerated() {
      console.log('FIN chargement PDF');
      this.showLoader.close();
    },
    createInventaireProducts() {
      this.$emit('onCreateInventaireProducts');
    },
    displayListProducts() {
      this.displayEmbed = false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

.icon-family-not-filled {
  margin-left: 15px;
  font-size: 25px;
}
.icon-family-not-filled.el-icon-circle-close {
  color: red;
}
.icon-family-not-filled.el-icon-circle-check {
  color: #2ecc71;
}

.el-collapse-item__header {
  padding-left: 15px;
}
</style>

<style scoped lang="stylus">

$margin = 25px;

h3
  margin 40px 0 0

ul
  list-style-type none
  padding 0

li
  display inline-block
  margin 0 10px

a
  color #42b983

h2
  margin : $margin;

.el-alert, .box-card-message-inventaire {
    margin: $margin;
    width: 80%;
}

.no-saisie-text
  margin: $margin;

.el-collapse-item__header {
    font-size: 20px;
    margin-left: 10px;
}

.hidden {
  display: none;
}

.button-action-gener-inventaire {
  margin: 0px $margin;
}

.embedPdf {
  margin: $margin;
}

.button-action-back-list {
  margin: 0px $margin;
  display: block;
}
@media print
{
  .content-family-for-print span {
    font-weight: bold;
  }
  .content-family-for-print table {
    width: 100%;
    border-collapse: collapse;
  }
}

#list-products
  margin-left: 1px;

.new-message-icon {
  position: absolute;
  right: 45px;
  top: 10px;
  font-size: 25px;
  color: #f56c6c;
}

/*
.content-family-for-print table,.content-family-for-print th,.content-family-for-print td {
  border: 1px solid black;
}*/
</style>
